<div
    [id]="form?.displayId()"
    class="social-group widget-specific-nav-align"
    [class.social-zero-variant]="isZero"
    [style.--social-group-justify]="groupJustify()"
    [style.--social-group-justify-mobile]="groupJustifyMobile()"
    [style.--social-group-justify-tablet]="groupJustifyTablet()"
    [style.--social-group-transform]="groupTransform()"
    [style.--social-group-transform-mobile]="groupTransformMobile()"
    [style.--social-group-z-index]="groupZIndex()"
    [style.--social-group-z-index-mobile]="groupZIndexMobile()"
    [style.--social-group-margin]="groupMargin()"
    [style.--social-icon-size]="iconSize()"
>
    @for (social of form.socialItems(); track $index) {
        <a [class]="getStyleList(social)" [style]="socialItemCssVars()">
            @if (social.type === EButtonType.icon) {
                <img [src]="getSocialIconSrcBySocial(social)" [alt]="social.socialNetwork" />
            }
            @if (social.type === EButtonType.button) {
                <div [innerHTML]="getIcon(social.socialNetwork)" class="icon"></div>
                <span>{{ social.name }}</span>
            }
        </a>
    }
</div>
